import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const CgvPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      auth: null,
      path: routesUrl.cgv,
      component: React.lazy(() => import('./CgvPage')),
    },
  ],
};

export default CgvPageConfig;
